Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "avatar3582682989",
  {"root":"avatar3582682989--root","content":"avatar3582682989--content"},
  "",
  1,
  "avatar3582682989"
);

